import * as _ from "lodash";
declare var $: any;

export module DialogService {

	// tslint:disable-next-line:only-arrow-functions
	export async function showConfirm(header: string, content: string, icon: string = "icon trash"){
			let id = _.uniqueId();
			let confirm = `
				<div id="${id}" class="ui basic modal">
					<div class="ui icon header">
						<i class="${icon}"></i>
							${header}
					</div>
					<div class="content">
						<p>${content}</p>
					</div>
					<div class="actions">
					<div class="ui red basic cancel inverted button">
						<i class="remove icon"></i>
							No
					</div>
					<div class="ui green ok inverted button">
						<i class="checkmark icon"></i>
							Yes
					</div>
				</div>
				</div>
			`;

			$("body").append(confirm);

			return new Promise((resolve) => {
				$(".ui.basic.modal").modal({
					"closable" : false,
					"onDeny": () => {
						$(".ui.basic.modal").modal("hide");
						$("body").remove(`#${id}`);
						resolve(false);
						return true;
					},
					"onApprove" : () => {
						$(".ui.basic.modal").modal("hide");
						$("body").remove(`#${id}`);
						resolve(true);
						return true;
					}
				}).modal("show");
			});
	}
}



// WEBPACK FOOTER //
// ./src/services/dialog-service.ts